import React from 'react';
import {Link} from 'react-router-dom';
import goImg from '../images/good-order-v3.jpg';

import translation from '../translations.json';

import {LanguageContext} from '../LanguageContext';
import LanguageSelector from './LanguageSelector';

const Home = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div>
          <div className="text-right">
            <img className="w-90" src={goImg} alt="see-it-sort-it-report-it" />
          </div>

          <div className="p-4 pt-8">
            <LanguageSelector />
            <div className="text-center mt-4 px-2">
              <div className="text-2xl bg-blue hover:bg-blue text-white font-bold py-2 px-3 m-3 rounded">
                <Link to="/site" className="no-underline text-white">
                  {translation.home[lang.selected].START_SUBMISSION}
                </Link>
              </div>
            </div>
          </div>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js